import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "view-tenant-review-header w-100 d-flex align-items-center justify-content-between" }
const _hoisted_2 = { class: "d-flex align-items-center view-tenant-review-content" }
const _hoisted_3 = { class: "profile-info" }
const _hoisted_4 = { class: "d-flex align-items-center rating" }
const _hoisted_5 = { class: "name mb-0" }
const _hoisted_6 = { class: "d-flex flex-wrap align-items-center" }
const _hoisted_7 = { class: "fs-5 fw-bolder rating-text" }
const _hoisted_8 = { class: "d-flex align-items-center other-details" }
const _hoisted_9 = { class: "d-flex align-items-center type" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-user icon" }, null, -1)
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "d-flex align-items-center phone" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-alt icon" }, null, -1)
const _hoisted_14 = { class: "text" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "d-flex align-items-center mail" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope icon" }, null, -1)
const _hoisted_18 = { class: "text" }
const _hoisted_19 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Avatar, { src: _ctx.avatarSrc }, null, 8, ["src"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.fullName), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_form_item, { class: "mb-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_rate, {
                  disabled: "",
                  size: "small",
                  class: "rating-size",
                  "model-value": parseFloat(_ctx.averageRating)
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.rate) + "/5.0 ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.tenantRole), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", _hoisted_14, [
              _createElementVNode("a", {
                href: `tel: ${_ctx.currentTenant.mobile_number}`
              }, _toDisplayString(_ctx.currentTenant.mobile_number), 9, _hoisted_15)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, [
              _createElementVNode("a", {
                href: `mailto: ${_ctx.currentTenant.email}`
              }, _toDisplayString(_ctx.currentTenant.email), 9, _hoisted_19)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitTenantReference(_ctx.tenant?.id))),
      class: "btn btn-new-design-primary btn-lg btn-submit"
    }, " Submit Tenant Reference ")
  ]))
}